import { render } from "./emergency-care-badge.vue?vue&type=template&id=142a43b8"
import script from "./emergency-care-badge.vue?vue&type=script&lang=js"
export * from "./emergency-care-badge.vue?vue&type=script&lang=js"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__